import './Header.css';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import client from './utils/sanity/client.ts';

export default function Header() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    client.fetch(`*[_type == "banner"] {
      title,
      message,
      link,
    }[0]`)
    .then((data) => {
      console.log("Fetched banner data:", data);
      if (data) {
        setBanner(data);
        adjustHeaderHeight(data.message);
      } else {
        adjustHeaderHeight(null);
      }
    })
    .catch((error) => {
      console.error("Error fetching banner data:", error);
      adjustHeaderHeight(null);
    });
  }, []);

  const handleBannerClose = () => {
    // Close the banner by hiding it
    const bannerElement = document.getElementById("scrolling-banner");
    if (bannerElement) {
      bannerElement.style.display = "none";
    }

    // Adjust the height of header-content based on media queries
    adjustHeaderHeight(null);
  }

  const adjustHeaderHeight = (bannerMessage) => {
    const viewportWidth = window.innerWidth;
    const headerContent = document.querySelector(".header-container");
    if (headerContent) {
      if (bannerMessage) {
        // Adjust height with banner
        if (viewportWidth >= 1024) {
          headerContent.style.height = "14rem"; // Height for large screens with banner
        } else if (viewportWidth >= 768) {
          headerContent.style.height = "13rem"; // Height for medium screens with banner
        } else {
          headerContent.style.height = "10.5rem"; // Height for small screens with banner
        }
      } else {
        // Adjust height without banner
        if (viewportWidth >= 1024) {
          headerContent.style.height = "11rem"; // Height for large screens without banner
        } else if (viewportWidth >= 768) {
          headerContent.style.height = "10rem"; // Height for medium screens without banner
        } else {
          headerContent.style.height = "9rem"; // Height for small screens without banner
        }
      }
    }
  }

  // State variables to manage the burger menu and menu visibility
  const [burger_class, setBurgerClass] = useState("burger-bar unclicked");
  const [menu_class, setMenuClass] = useState("menu hidden");
  const [isMenuClicked, setIsMenuClicked] = useState(false);

  // Function to update the burger menu and menu visibility
  const updateMenu = () => {
    if (!isMenuClicked) {
      setBurgerClass("burger-bar clicked");
      setMenuClass("menu visible");
    } else {
      setBurgerClass("burger-bar unclicked");
      setMenuClass("menu hidden");
    }
    setIsMenuClicked(!isMenuClicked);
  }

  // Function to handle link clicks and reset the menu state
  const handleLinkClick = () => {
    setBurgerClass("burger-bar unclicked");
    setMenuClass("menu hidden");
  };

  return (
    <div className='header-container'>
      <div className='header-strip'></div>
      {banner && banner.message && (
        <div className="scrolling-banner" id='scrolling-banner'>
          <marquee behavior="scroll" direction="left">
            <Link to={banner.link}>{banner.message}</Link>
          </marquee>
          <button className='close-marque' onClick={handleBannerClose}>X</button>
        </div>
      )}
      <div className="descriptors">
        <h2>WARRIOR POET</h2>
        <h2>SINGER-SONGWRITER</h2>
        <h2>STORYTELLER</h2>
      </div>
      <div className='kebab-header-content'>
        <div className="kebab-menu-container">
          <div className="kebab-menu" onClick={updateMenu}>
            <div className={burger_class}>*</div>
            <div className={burger_class}>*</div>
            <div className={burger_class}>*</div>
          </div>
        </div>
        <div className="h1-container">
          <div id='h1'>
            <Link to="/" style={{ textDecoration: 'none' }} onClick={handleLinkClick}>
              <h1>ÆTHEL MUSIC</h1>
            </Link>
          </div>
        </div>
      </div>
      <nav>
        <div className={menu_class}>
          <div className='menusubs'>
            <span id='music'>
              <Link to="/playlist" onClick={handleLinkClick}>PLAYLIST</Link>
            </span>
          </div>
          <span><Link to="/videos" onClick={handleLinkClick}>VIDEOS</Link></span>
          <div className='menusubs'>
            <span id='about'>ABOUT</span>
            <ul className="submenu-2">
              <li><Link to="/about" onClick={handleLinkClick}>BIO</Link></li>
              <li><Link to="/blog" onClick={handleLinkClick}>NEWS</Link></li>
            </ul>
          </div>
          <span><Link to="./book" onClick={handleLinkClick}>STORYBOOK</Link></span>
          <span><Link to="./sync" onClick={handleLinkClick}>SYNC</Link></span>
          <span><Link to="/contact" onClick={handleLinkClick}>CONTACT</Link></span>
        </div>
      </nav>
      <div className='header-strip'></div>
    </div>
  );
}
